import { render, staticRenderFns } from "./ResourceRank.vue?vue&type=template&id=6edd703e&scoped=true"
import script from "./ResourceRank.vue?vue&type=script&lang=js"
export * from "./ResourceRank.vue?vue&type=script&lang=js"
import style0 from "./ResourceRank.vue?vue&type=style&index=0&id=6edd703e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd703e",
  null
  
)

export default component.exports